import { useState } from "react";

const useSnackbar = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [severity, setSeverity] = useState<
    "success" | "error" | "info" | "warning"
  >("success");
  const [open, setOpen] = useState(false);

  const showSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning" = "success"
  ) => {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);
  };
  const closeSnackbar = () => {
    setOpen(false);
  };

  return {
    message,
    severity,
    open,
    showSnackbar,
    closeSnackbar,
  };
};

export default useSnackbar;
